<div class="mx-4 mx-md-5 mt-5">
    <h5>{{ "Set the opportunity details" | translate }}</h5>
    <p>
        {{ "Just review, edit, and update it with new information" | translate }}
    </p>
</div>

<form [formGroup]="opportunityForm">
    <div class="card-data">
        <h4>{{ "Opportunity Details" | translate }}</h4>

        <div class="row m-0">
            <div class="col-12 col-sm-6 px-0 px-md-2">
                <label>{{ "Job Title" | translate }} <span class="required-star">*</span></label>
                <input type="text" placeholder="{{ 'Enter job title' | translate }}" formControlName="jobTitle"
                    [class.input-error]="jobTitleInvalid" />
                <span class="error" *ngIf="jobTitleInvalid">
                    {{ "Job Title is required" | translate }}
                </span>
            </div>

            <div class="col-12 col-sm-6 px-0 px-md-2">
                <label>{{ "Keywords (optional)" | translate }}</label>
                <div class="keywords-input-container">
                    <input type="text" placeholder="{{ 'Enter keyword and press Enter' | translate }}"
                        [(ngModel)]="keywordInput" [ngModelOptions]="{ standalone: true }"
                        (keypress)="onKeywordKeyPress($event)" />
                </div>

                <div class="keywords-list" *ngIf="keywords.length > 0">
                    <span class="keyword-tag" *ngFor="let keyword of keywords; let i = index">
                        {{ keyword }}
                        <i class="pi pi-times" (click)="removeKeyword(i)"></i>
                    </span>
                </div>
            </div>

            <div class="col-12 col-sm-6 px-0 px-md-2">
                <label>{{ "Job Description" | translate }} <span class="required-star">*</span></label>
                <textarea placeholder="{{ 'Enter job description' | translate }}" formControlName="jobDescription"
                    rows="5" [class.input-error]="jobDescriptionInvalid"></textarea>
                <span class="error" *ngIf="jobDescriptionInvalid">
                    {{ "Job Description is required" | translate }}
                </span>
            </div>

            <div class="col-12 col-sm-6 px-0 px-md-2">
                <label>{{ "Language" | translate }}</label>
                <select formControlName="language">
                    <option *ngFor="let lang of languages" [value]="lang.code">
                        {{ lang.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="next-container px-4">
        <button class="border-button m-3" type="button" (click)="onPrevious()">
            {{ "Back" | translate }}
        </button>
        <button class="gradient-button m-3" type="button" (click)="onNext()" [disabled]="opportunityForm.invalid">
            {{ "Next" | translate }}
        </button>
    </div>
</form>